import React, {useState, useRef} from 'react';
import AddressModal from "../../AddressModal/AddressModal";
import InfoModal from "../../InfoModal/InfoModal";
import {Link} from "react-router-dom";
import {Accordion} from "react-bootstrap";

const App3 = () => {

    const [showAddressModal, setShowAddressModal] = useState(false);

    const handleShowAddressModal = () => setShowAddressModal(true);
    const handleCloseAddressModal = () => setShowAddressModal(false);
    const modalRef = useRef();
    const modalRef2 = useRef();
    const photoVideoGuideTitle = "Участнику вступительных испытаний, проводимых ГГУ";

    const photoVideoGuide = (
        <div>
            <div>
                <h3>
                    Памятка, для поступающих на творческие направления:
                </h3>
                <h4>На творческий экзамен по рисунку необходимо иметь при себе:</h4>
                <ul>
                    <li>Лист формата А2</li>
                    <li>Карандаши простые</li>
                    <li>Ластик</li>
                    <li>Кнопки канцелярские или молярный скотч</li>
                    <li><i>Хорошее настроение</i></li>
                </ul>
                <h4>На творческий экзамен по живописи необходимо иметь при себе:</h4>
                <ul>
                    <li>Лист формата А2</li>
                    <li>Краски на выбор (акварель, гуашь, темпера), кисти</li>
                    <li>
                        Кнопки канцелярские или молярный скотч, баночка для воды, тряпочка
                    </li>
                    <li><i>Хорошее настроение</i></li>
                </ul>
                <h4>На творческий экзамен по композиции необходимо иметь при себе:</h4>
                <ul>
                    <li>Лист форматом А2</li>
                    <li>Краски на выбор (акварель, гуашь, темпера), кисти</li>
                    <li>
                        Кнопки канцелярские или молярный скотч, баночка для воды, тряпочка
                    </li>
                    <li>Карандаш</li>
                    <li>Линейка, треугольник</li>
                    <li>Циркуль</li>
                    <li><i>Хорошее настроение</i></li>
                </ul>
                <h4>На творческий экзамен по скульптуре необходимо иметь при себе:</h4>
                <ul>
                    <li>Стеки</li>
                    <li><i>Хорошее настроение</i></li>
                </ul>
            </div>
        </div>
    );

    const testingFeaturesTitle = "Особенности проведения тестирования";

    const testingFeatures = (
        <div>
            <h3>Особенности проведения тестирования:</h3>
            <ul style={{listStyle: 'decimal'}}>
                <li>На выполнение теста абитуриентам отводится 60 минут.</li>
                <li>Тестирование включает 20 заданий, каждое из которых содержит вопрос, требующий выбора
                    правильного ответа.</li>
                <li>Каждое правильно выполненное задание оценивается 5 баллами.</li>
            </ul>
            <h3>Во время экзамена запрещается:</h3>
            <ul>
                <li>громко разговаривать</li>
                <li>выходить из помещения без разрешения наблюдателя</li>
                <li>использовать любые технические средства в качестве шпаргалок</li>
                <li>производить фотосъемку работ</li>
                <li>использовать любые мобильные и цифровые устройства во время испытаний</li>
                <li>задерживать сдачу работы по истечении времени, отведённого на выполнение работы</li>
            </ul>
        </div>
    );

    return (
        <div className="DocumentLinksPage__content-container">
            <h2>Вступительные испытания</h2>
            <p>Все вступительные испытания проводятся на <b>русском языке</b>.
                Проведение вступительного испытания на иностранном языке
                (за исключением вступительного испытания по иностранному языку) и на языке субъектов
                Российской Федерации при поступлении в ГГУ не предусмотрено.</p>
            <p>
                <h6>Университет проводит вступительные испытания:</h6>
                <ul>
                    <li>в рамках контрольных цифр приема очно</li>
                    <li>по договорам об оказании платных образовательных услуг очно или
                        с использованием дистанционных технологий.
                    </li>
                </ul>
                <h6>Минимальные баллы по общеобразовательным дисциплинам:</h6>
                <ul>
                    <li>математика – 60 баллов;</li>
                    <li>география – 60 баллов;</li>
                    <li>педагогика – 60 баллов;</li>
                    <li>педагогика и психология – 60 баллов;</li>
                    <li>теория и история народной художественной культуры – 60 баллов;</li>
                    <li>культурология – 60 баллов;</li>
                    <li>история искусств – 60 баллов;</li>
                </ul>
            </p>

            <p>
                <h3>Вступительные испытания проводятся:</h3>
                <ul>
                    <li>Для поступающих на бюджет с 12 по 21 августа {new Date().getFullYear()} г.</li>
                    <li>Для поступающих на платную основу с 11 по 21 августа {new Date().getFullYear()} г.</li>
                </ul>
            </p>

            <p>
                <b>Место проведения вступительных испытаний:</b> Московская область, Раменский городской округ, пос.
                Электроизолятор, д. 67
                (<Link to="#" onClick={(e) => {
                e.preventDefault();
                handleShowAddressModal();
            }}>
                как добраться
            </Link>)
            </p>
            <AddressModal show={showAddressModal} onHide={handleCloseAddressModal} showRepresentation={false}/>
            <InfoModal
                ref={modalRef}
                title={photoVideoGuideTitle}
                description={photoVideoGuide}
            />

            <InfoModal
                ref={modalRef2}
                title={testingFeaturesTitle}
                description={testingFeatures}
            />

            <p>
                <a
                    href="https://www.art-gzhel.ru/abitur/magistr/doc/mag_2025.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Расписание вступительных испытаний
                </a> <br/>
            </p>
            <p>
                <h5>Программы вступительных испытаний, проводимых организацией самостоятельно:</h5>
                <Accordion>
                    <Accordion.Item eventKey="1">
                        <Accordion.Header>Программы вступительных испытаний</Accordion.Header>
                        <Accordion.Body>
                            <ul>
                                <li>
                                    <a href="https://www.art-gzhel.ru/abitur/magistr/doc/%D0%93%D0%B5%D0%BE%D0%B3%D1%80%D0%B0%D1%84%D0%B8%D1%8F.pdf"
                                       target="_blank"
                                       rel="noopener noreferrer">
                                        География
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.art-gzhel.ru/abitur/magistr/doc/hist_iskusstv.pdf"
                                       target="_blank"
                                       rel="noopener noreferrer">
                                        История искусств
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.art-gzhel.ru/abitur/magistr/doc/%D0%9C%D0%B0%D1%82%D0%B5%D0%BC%D0%B0%D1%82%D0%B8%D0%BA%D0%B0.pdf"
                                       target="_blank"
                                       rel="noopener noreferrer">
                                        Математика
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.art-gzhel.ru/abitur/magistr/doc/Pedagogika.pdf" target="_blank"
                                       rel="noopener noreferrer">
                                        Педагогика
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.art-gzhel.ru/abitur/magistr/doc/Pedagogika_i_psihologia.pdf"
                                       target="_blank"
                                       rel="noopener noreferrer">
                                        Педагогика и психология
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.art-gzhel.ru/abitur/magistr/doc/%D0%9A%D1%83%D0%BB%D1%8C%D1%82%D1%83%D1%80%D0%BE%D0%BB%D0%BE%D0%B3%D0%B8%D1%8F.pdf"
                                       target="_blank"
                                       rel="noopener noreferrer">
                                        Культурология
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.art-gzhel.ru/abitur/magistr/doc/TINHK.pdf"
                                       target="_blank"
                                       rel="noopener noreferrer">
                                        Теория и история народной художественной культуры
                                    </a>
                                </li>
                            </ul>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
            </p>
        </div>
    );
}

export default App3;